import { render, staticRenderFns } from "./MpMealChip.vue?vue&type=template&id=6200703c&lang=pug&"
import script from "./MpMealChip.vue?vue&type=script&lang=js&"
export * from "./MpMealChip.vue?vue&type=script&lang=js&"
import style0 from "./MpMealChip.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports